module.exports = __webpack_public_path__ + "img/icon-saveposter.50b1850b.png";